<template>
	<div>
		<a-layout class="layout-default" id="layout-default" :class="[route.meta.layoutClass]">
			<DefaultHeader></DefaultHeader>
			<a-layout-content>
				<div class="main">
					<router-view />
				</div>
			</a-layout-content>
			<DefaultFooter></DefaultFooter>
			<Social></Social>
		</a-layout>
		<MenuBottom></MenuBottom>
	</div>
</template>
<script lang="ts" setup>
import DefaultHeader from "@/components/Headers/DefaultHeader.vue";
import DefaultFooter from "@/components/Footers/DefaultFooter.vue";
import { useRouter, useRoute } from "vue-router";
import Social from '@/components/social/Social.vue'
import MenuBottom from '@/components/menu/MenuBottom.vue'
const route = useRoute();
</script>
